import React, { useCallback } from 'react';

import { OfferBadges } from 'components/offer-badges';
import BlockRenderer from 'components/sanity-block-renderer';
import { isButtonLikeKeypress } from 'utils/event';

import { Body, Content, Footer, Heading, StyledPicture, Wrapper } from './styled';
import TicketPath from './ticket-path';
import { IOfferLayoutProps } from './types';

const OfferLayout: React.FC<IOfferLayoutProps> = ({
  className,
  displayLoginRequiredBadge,
  endingIn,
  id,
  offer,
  onClick,
  platforms,
}) => {
  const onKeyUp = useCallback(
    (e: React.KeyboardEvent) => {
      if (isButtonLikeKeypress(e)) {
        e.preventDefault();
        onClick(e);
      }
    },
    [onClick]
  );

  return (
    <Wrapper
      className={className}
      role="button"
      tabIndex={0}
      aria-pressed="false"
      onKeyUp={onKeyUp}
      onClick={onClick}
    >
      <TicketPath id={id} />
      <div>
        {offer?.localizedImage?.locale?.app && (
          <StyledPicture
            alt=""
            clipPathId={id}
            image={offer?.localizedImage?.locale?.app!}
            placeholderAspectRatio={1.5}
            objectFitContain={false}
          />
        )}
      </div>
      <Content>
        <Heading>
          <BlockRenderer content={offer?.name?.localeRaw} />
        </Heading>
        <Body>
          <BlockRenderer content={offer?.description?.localeRaw} />
        </Body>
        <Footer>
          <OfferBadges
            platforms={platforms}
            displayLoginRequiredBadge={displayLoginRequiredBadge}
            endingIn={endingIn}
          />
        </Footer>
      </Content>
    </Wrapper>
  );
};

export default OfferLayout;
